import { reduxForm } from 'redux-form';
import Component from './RoleForm';
import { validate } from './validate';

const initialValues = {
  role: '',
  userType: '',
  permissions: [],
};

const RoleForm = reduxForm({
  form: 'formPermissionUser',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default RoleForm;
